import { Space } from 'ngx-fabric8-wit';


export type SpaceState = Space;

export const initialState: SpaceState | null = null;
